import Vue from 'vue'
import VueRouter from 'vue-router'

import login from './routes/login'
import home from './routes/home'
import funcionarios from './routes/funcionarios'
import almoxarifado from './routes/almoxarifado'
import motoristas from './routes/motoristas'
import veiculos from './routes/veiculos'
import configuracao from './routes/configuracao'
import agenda from './routes/agenda'
import carga from './routes/carga'
import alugueis from './routes/alugueis'
import financeiro  from './routes/financeiro'
import onibus  from './routes/onibus'

Vue.use(VueRouter)

let routes = []
routes = routes.concat(
  login,
  home,
  funcionarios,
  almoxarifado,
  motoristas,
  veiculos,
  configuracao,
  agenda,
  carga,
  alugueis,
  financeiro,
  onibus
);

routes.push({
  path: '*',
  component: () => import('@/views/Erro.vue'),
  children: [
    {
      name: 'Error',
      path: '',
      component: () => import('@/views/Erro.vue'),
    },
  ],
})

const router = new VueRouter({
  mode: process.env.VUE_APP_MODE,
  base: process.env.BASE_URL,
  routes
})

export default router
